export const BRF_THEME = 'brf';
export const BRFSOLO_THEME = 'brfSolo';
